import { Component, OnInit } from '@angular/core';
import { StringsService } from '../../services/strings/strings.service';
import { AppSettings } from '../../PRE-LOAD/app-settings';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { RoutingStateService } from '../../services/routing-state/routing-state.service';
import { ErrorService } from '../../services/errors/error.service';

@Component({
    selector: 'rttd-error-page',
    templateUrl: './error-page.component.html',
    styles: [
        require('./error-page.component.scss').default.toString(),
        require(`./error-page.component.${environment.brand}.scss`).default.toString()
    ]
})
export class ErrorPageComponent implements OnInit {
    content: any;
    errorType: string;

    constructor(
        private router: Router,
        private stringsService: StringsService,
        private appSettings: AppSettings,
        private routingState: RoutingStateService,
        private errorService: ErrorService
    ) { }

    ngOnInit() {
        /**
         * Get the latest error code and throw the appropriate error.
         */
        this.errorService.error$.subscribe((errorCode: string) => {
            this.stringsService.get().subscribe((data: any) => {
                if (!data) {
                    return;
                }

                data = data['ErrorPages'];
                switch (errorCode) {
                    case 'time_unavailable':
                        this.content = data.timeslot_unavailable;
                        this.errorType = 'timeslotUnavailable';
                        break;

                    case 'cancellation_error':
                        this.content = data.cancellation_error;
                        this.errorType = 'genericError';
                        break;

                    case 'guest_limit':
                        this.content = data.guest_limit;
                        this.errorType = 'guestLimit';
                        break;

                    default:
                        this.content = data.generic_error;
                        if (this.content && this.content.message) {
                            this.content.message = this.content.message.replace('!retailerContactNumber', `<strong>${this.appSettings.retailerSalesTelephoneNumber}</strong>`);
                        }
                        this.errorType = 'genericError';
                        break;
                }
            });
        });
    }

    /**
     * @description Navigates to the 'select-appointment' route.
     */
    navigateToSelectAppointment() {
        this.router.navigate(['/select-appointment'], { skipLocationChange: true });
    }

    /**
     * @description Navigates to the 'event-personal-information' route.
     */
    navigateToEventPersonalInformation() {
        this.router.navigate(['event-personal-information'], { skipLocationChange: true, fragment: 'rttd' });
    }

    /**
     * Navigate to the page before the error.
     */
    back() {
        this.router.navigate([this.routingState.getPreviousBy(3)], {skipLocationChange: true});
    }

}
